"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerPageChooseTenant = void 0;
const react_1 = __importStar(require("react"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const ListGroup_1 = __importDefault(require("react-bootstrap/ListGroup"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const react_router_dom_1 = require("react-router-dom");
const authContext_1 = require("../../context/authContext");
const tenantLoader = __importStar(require("../../models/helper/tenantLoader"));
const useFirestore_1 = require("../../utils/useFirestore");
const Spinner_1 = require("../spinner/Spinner");
const ManagerPageChooseTenant = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [auth, authInfo] = (0, authContext_1.useAuth)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const [tenants, setTenants] = (0, react_1.useState)();
    // Load tenants the user is a member of (to get full tenant names).
    (0, react_1.useEffect)(() => {
        const abortController = new AbortController();
        async function loadTenants() {
            if (authInfo.user.isSuperadmin) {
                setTenants(await tenantLoader.loadAllTenants(firestore));
            }
            else {
                setTenants(await tenantLoader.loadTenants(firestore, authInfo.user.memberOf));
            }
        }
        loadTenants();
        return () => abortController.abort();
    }, []);
    if (tenants === undefined) {
        return react_1.default.createElement(Spinner_1.Spinner, { className: "mt-3 mx-auto" });
    }
    else if (tenants.length === 0) {
        return (react_1.default.createElement(Container_1.default, { className: "mt-5 text-center" },
            react_1.default.createElement("h2", null, "Keine Mitgliedschaften"),
            react_1.default.createElement("p", null, "Du musst von einem Administrator zu einem Team hinzugef\u00FCgt werden."),
            react_1.default.createElement("a", { href: "/" }, "Zur\u00FCck zu Home")));
    }
    else if (tenants.length === 1) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: `/manager/${tenants[0].id}/`, replace: true });
    }
    else {
        return (react_1.default.createElement(Container_1.default, null,
            react_1.default.createElement(Row_1.default, { className: "mt-5" },
                react_1.default.createElement(Col_1.default, { sm: { span: 10, offset: 1 }, md: { span: 6, offset: 3 }, lg: { span: 4, offset: 4 } },
                    react_1.default.createElement(Card_1.default, null,
                        react_1.default.createElement(Card_1.default.Header, { as: "h4" }, "Mandant w\u00E4hlen"),
                        react_1.default.createElement(Card_1.default.Body, { className: "p-0" },
                            react_1.default.createElement(ListGroup_1.default, { variant: "flush" }, tenants.map((tenant) => {
                                return (react_1.default.createElement(ListGroup_1.default.Item, { key: tenant.id, action: true, onClick: () => navigate(`/manager/${tenant.id}/`) }, tenant.name));
                            }))))))));
    }
};
exports.ManagerPageChooseTenant = ManagerPageChooseTenant;
